<template>
  <div class="pt-3">
    <v-form @submit.prevent="searchUp">
      <v-col class="d-flex">
        <v-text-field
          v-model="searchKey"
          hide-details="auto"
          label="Search"
          outlined
          autofocus
          dense
          clearable
        />
        <v-btn
          :disabled="!searchKey"
          class="info ml-2"
          type="submit"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-form>
    <v-col>
      <template v-if="showRepairs">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Date
                </th>
                <th class="text-left">
                  TRX
                </th>
                <th class="text-left">
                  Customer
                </th>
                <th class="text-left">
                  Phone
                </th>
                <th class="text-left">
                  email
                </th>
                <th class="text-left">
                  Device
                </th>
                <th class="text-left">
                  S.Number
                </th>
                <th class="text-left">
                  Imei
                </th>
                <th class="text-left">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="repairs.length > 0">
                <tr
                  v-for="repair in repairs"
                  :key="repair.key"
                >
                  <td>{{ repair.created_at }}</td>
                  <td>{{ repair.key }}</td>
                  <td>{{ repair.name }}</td>
                  <td>{{ repair.phone }}</td>
                  <td>{{ repair.email }}</td>
                  <td>{{ repair.deviceName }}</td>
                  <td>{{ repair.sNumber }}</td>
                  <td>{{ repair.imie }}</td>
                  <td>
                    <template v-if="repair.status">
                      completed
                    </template>
                    <template v-else>
                      Pending
                    </template>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td
                    colspan="9"
                    class="error--text"
                  >
                    Not found
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </template>
      <template v-else>
        <strong>Tip :</strong>
        <p>
          Search repair orders with following keys
        </p>
        <ul>
          <li>By Tracking ID</li>
          <li>By Customer Name</li>
          <li>By Customer Phone</li>
          <li>By Customer Email</li>
          <li>By IMIE</li>
          <li>By Serial Number</li>
          <li>By Device Model</li>
        </ul>
      </template>
    </v-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showRepairs: false,
      searchKey: "",
      repairs: [],
    };
  },
  watch: {
    searchKey() {
      if (this.searchKey === "" || this.searchKey === null) {
        this.$data.repairs = [];
        this.$data.showRepairs = false;
      }
    },
  },
  methods: {
    searchUp() {
      window.axios
        .post("/repair-search", { key: this.searchKey })
        .then((response) => {
          this.$data.showRepairs = true;
          this.$data.repairs = response.data.items;
        });
    },
  },
};
</script>
